<template>
  <svg class="o-icon"><use xlink:href="#close-small"></use></svg>
</template>

<script>
export default {
  name: 'DeselectButton'
}
</script>
